import React from 'react';
import { Card, CardContent, CardMedia, Typography, Chip } from '@mui/material';

const ServiceCard = ({ image, title, priceFrom }) => {
  return (
    <Card
      elevation={0}
      sx={{
        height: '100%',
        borderRadius: 2,
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        boxShadow: '0 16px 40px rgba(15, 23, 42, 0.06)',
        transition: 'transform 0.25s ease, box-shadow 0.25s ease',
        '&:hover': {
          transform: 'translateY(-6px)',
          boxShadow: '0 20px 60px rgba(15, 23, 42, 0.12)'
        }
      }}
    >
      <CardMedia
        component="img"
        height="220"
        image={image}
        alt={title}
        sx={{ objectFit: 'cover' }}
      />
      <CardContent sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
          {title}
        </Typography>
        <Chip
          label={`From ${priceFrom}`}
          color="primary"
          size="small"
          sx={{ borderRadius: 200, fontWeight: 500 }}
        />
      </CardContent>
    </Card>
  );
};

export default ServiceCard;
